// extracted by mini-css-extract-plugin
module.exports = {"video":"media-asset_video__niFDm"};